<template>
  <div class="preview-table">
    <h2>Quick Preview</h2>
    <slot-table v-if="quickPreviewLinks" :tableData="quickPreviewLinks.items" :data="quickPreviewLinks.items"
                :columns="table.columns">

      <template slot="client" slot-scope="props">
          <span>
            <router-link :to="{ path: `/client/${props.item.creative.campaign.client.hash_id}` }">
              {{ props.item.creative.campaign.client.name }}
            </router-link>
          </span>
      </template>

      <template slot="campaign" slot-scope="props">
          <span>
            <router-link :to="{ path: `/campaigns/${props.item.creative.campaign.hash_id}` }">
              {{ props.item.creative.campaign.name }}
            </router-link>
          </span>
      </template>

      <template slot="creative" slot-scope="props">
          <span>
            <router-link :to="{ path: `/creatives/${props.item.creative.hash_id}/bulk` }">
              {{ props.item.creative.name }}
            </router-link>
          </span>
      </template>

      <template slot="status" slot-scope="props">
          <span :class="statusCss(props.item)">
            {{ statusText(props.item) }}
          </span>
      </template>

      <template slot="link_count" slot-scope="props">
        <span>{{ props.item.link_count_completed }} / {{ props.item.link_count }} </span>
      </template>

      <template slot="date" slot-scope="props">
        <span>{{ props.item.date_created.value | formatDateTime }} </span>
      </template>

      <template slot="linkActions" slot-scope="props" v-if="!props.item.deleted">
        <a class="btn btn-primary btn-xs" :href="previewUrl(props.item.preview_url)" target="_blank"
           title="Launch Preview Link"><i class="fa fa-link" aria-hidden="true"></i></a>
        <button-cta title="Refresh creative on Preview link" class="btn btn-info btn-xs" data-modalType="refreshLink"
                    :data-modalID="props.item.hash_id" :data-modalFieldType="'quick-preview'" :onClick="showModalHandler">
          <i class="fa fa-retweet" aria-hidden="true"></i>
        </button-cta>
        <button-cta title="Edit Preview link name" data-modalType="editLink" :data-modalField="props.item.name"
                    :data-modalID="props.item.hash_id" :onClick="showModalHandler"
                    :data-modalFieldType="'quick-preview'"
                    class="btn btn-warning btn-xs">
          <i class="fa fa-pencil" aria-hidden="true"></i>
        </button-cta>
        <button-cta title="Delete Preview Link" data-modalType="deleteLink" :data-modalID="props.item.hash_id"
                    :onClick="showModalHandler"
                    :data-modalFieldType="'quick-preview'"
                    class="btn btn-danger btn-xs">
          <i class="fa fa-trash" aria-hidden="true"></i>
        </button-cta>
      </template>

    </slot-table>
    <div class="row" v-if="showPager">
      <div class="col-sm-6">
      </div>
      <div class="col-sm-6">
        <pager :pagerData="quickPreviewLinks"
               :onPaginate="onPaginate"
               :onChangePageSize="onChangePageSize"
               :minItemsPerPage="quickPreviewLinks.pageSize"
               ref="pagerRef"
        />
      </div>
    </div>
    <div class="cnt-buttons">
      <button class="btn btn-primary"
              @click="goFullList"
              v-if="!showPager"
      >
        View all
      </button>
    </div>
  </div>
</template>

<script>

import HeadingWrap from '@/components/HeadingWrap/heading-wrap'
import SlotTable from '@/components/Table/table'
import ButtonCta from '@/components/Button/button'

import Pager from '@/components/Pager/pager'
import Tooltip from '@/components/Tooltip/tooltip'
import {linkMixin, LINKS_TABLE_TYPES} from '@/mixins/linkMixin'

import {API_URL} from '@/config'

export default {
  name: 'table-links-quick-preview',
  mixins: [linkMixin],
  components: {
    HeadingWrap,
    SlotTable,
    ButtonCta,
    Pager,
    Tooltip
  },
  props: {
    showPager: Boolean,
    showModalHandler: Function
  },
  data: () => ({
    search: '',
    table: {
      columns: {
        name: 'Name',
        date: 'Date Created',
        client: 'Client',
        status: 'Status',
        link_count: 'Creatives',
        campaign: 'Campaign Name',
        creative: 'Creative Name',
        linkActions: ''
      }
    }
  }),
  mounted () {
    this.setPagerData({type: LINKS_TABLE_TYPES.QUICK_PREVIEW, pageSize: this.showPager ? 50 : 10})
    this.getLinks(LINKS_TABLE_TYPES.QUICK_PREVIEW).then(() => {
      console.log('data loaded')
      // this.finishLoading()
    })
  },
  methods: {
    previewUrl (path) {
      return API_URL + path.substring(1)
    },
    // onLaunchModal () {},
    onPaginate (page) {
      this.setPagerData({type: LINKS_TABLE_TYPES.QUICK_PREVIEW, page})
      this.getLinks(LINKS_TABLE_TYPES.QUICK_PREVIEW)
    },
    onChangePageSize (pageSize) {
      this.setPagerData({type: LINKS_TABLE_TYPES.QUICK_PREVIEW, pageSize})
      this.getLinks(LINKS_TABLE_TYPES.QUICK_PREVIEW)
    },
    goFullList () {
      this.$router.push({name: 'ReviewLinksType', params: {type: LINKS_TABLE_TYPES.QUICK_PREVIEW}})
    },
    statusCss (item) {
      let labelType = 'warning'
      // if (item.deleted) labelType = 'danger'
      // if (item.feedback_submitted === true) labelType = 'success'
      switch (item.status) {
        case 'completed':
          labelType = 'success'
          break
        case 'in progress':
          labelType = 'info'
          break
        case 'error':
          labelType = 'danger'
          break
        case 'queued':
        default:
          labelType = 'warning'
          break
      }
      return `label label-${labelType} text-center text-capitalize`
    },
    statusText (item) {
      return item.status
    }
  }
}
</script>

<style lang="scss">
.preview-table {
  h2 {
    margin-bottom: 22px;
    font-size: 22px;
  }

  .cnt-buttons {
    margin-bottom: 54px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/LinksReviewComments/table-links-quick-preview.vue